import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './OverflowingText.css';
import Tooltip from '../molecules/Tooltip';

export default function OverflowingText({ children, className = '', hidePreview = false, ...otherProps }) {
    const elementRef = useRef(null);
    const elementClassName = classNames(css.overflowingText, className);
    const [previewText, setPreviewText] = useState('');

    const _addPreviewWhenOverflows = () => {
        if (hidePreview) return;
        const { offsetWidth, scrollWidth, textContent } = elementRef.current;

        if (offsetWidth >= scrollWidth) return;
        setPreviewText(textContent);
    };

    const _removePreview = () => setPreviewText('');

    return (
        <Tooltip delay={100} wrapperClass={elementClassName} title={previewText} disabled={!previewText}>
            <div
                ref={elementRef}
                className={elementClassName}
                onMouseEnter={_addPreviewWhenOverflows}
                onMouseLeave={_removePreview}
                {...otherProps}
            >
                {children}
            </div>
        </Tooltip>
    );
}

OverflowingText.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    className: PropTypes.string,
    hidePreview: PropTypes.bool,
};
